import React from 'react'
import { connect } from 'react-redux'
import { getListItems, changeListItem, nullDate } from 'tyan/public/utility'
import { hasChangedValues, getFormValue, changeItemsValue } from 'tyan/public/utility/formValues'
import MaterialSelect from './MaterialSelect'
class RequisitionDiv extends React.Component {
    state = {
    }

    componentDidMount = () => {
        const { id } = this.props
        this.handlerInitValue(id)
    }

    handlerInitValue = (id) => {
        Tyan.doPostEvent({
            event: 'GetRequisition',
            data: { id },
            onEnd: ({ errorMessage, initValues基本信息, initValues请购明细, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, initValues请购明细, changedValues请购明细: {}, optionsParas })
                }
            }
        })
    }

    handlerSave = (name = '') => {
        const { id, changedValues基本信息, changedValues请购明细 } = this.state
        const 币别 = getFormValue(this, '基本信息', '币别')
        if (!币别) {
            Ext.toast('币别必填')
            return
        }
        if (this.bChanged() || name !== '') {
            Tyan.doPostEvent({
                event: 'SaveRequisition',
                data: { id, changedValues基本信息, changedValues请购明细 },
                onEnd: ({ errorMessage, id }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        if (name != '选择物料')
                            Ext.toast('保存成功')
                        this.handlerInitValue(id)
                        if (name !== '') {
                            Tyan.pubForm.showDialog('选择物料', props => <MaterialSelect {...props} id={id}
                                onSave={() => this.handlerInitValue(id)} />)
                        }
                    }
                }
            })
        }
        else {
            if (name !== '') {
                Tyan.pubForm.showDialog('选择物料', props => <MaterialSelect {...props} id={id}
                    onSave={() => this.handlerInitValue(id)} />)
            }
        }
    }

    handlerDelete = () => {
        const { id } = this.state
        const { onSave, onClose } = this.props
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteRequisition',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onSave && onSave()
                        onClose && onClose()
                    }
                }
            }))
    }

    handleCurrencyNameChange = (v) => {
        const 申请时间 = getFormValue(this, '基本信息', '申请时间')
        Tyan.doPostEvent({
            event: 'GetExchangeRateByCurrency',
            data: { 币别: v, 申请时间 },
            onEnd: ({ errorMessage, ExchangeRate }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    changeItemsValue(this, '基本信息', ['汇率'], [ExchangeRate])
                    this.AutoCalculation()
                }
            }
        })
    }

    handlerDeleteInfo = (id) => {
        this.handlerSave('')
        const { id: reqPurchaseID } = this.state
        Tyan.doPostEvent({
            event: 'DeleteReqPurchaseInfo',
            data: { id },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('删除成功')
                    this.handlerInitValue(reqPurchaseID)
                }
            }
        })
    }

    handlerNoPurchase = (id) => {
        this.handlerSave('')
        const { id: reqPurchaseID } = this.state
        Tyan.doPostEvent({
            event: 'NoPurchase',
            data: { id },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('操作成功')
                    this.handlerInitValue(reqPurchaseID)
                }
            }
        })
    }


    AutoCalculation = (id = 0) => {
        const 汇率 = getFormValue(this, '基本信息', '汇率')
        const { list } = getListItems(this, '请购明细', '请购明细')
        var d合计金额 = 0
        var newList = list
        if (list.length > 0) {
            if (id > 0)
                newList = list.filter(o => o.id == id)
            newList.forEach(o => {
                var d本币单价 = o.原币单价
                var d本币含税单价 = 0
                var d本币未税金额 = 0
                var d本币含税金额 = 0
                var d税率 = 0
                if (o.税率) {
                    if (o.税率 == 'CN01：增值税13%')
                        d税率 = 0.13
                    else if (o.税率 == 'CN02：增值税9%')
                        d税率 = 0.09
                    else if (o.税率 == 'CN03：增值税6%')
                        d税率 = 0.06
                    else if (o.税率 == 'CN04：增值税3%')
                        d税率 = 0.03
                    else if (o.税率 == 'CN05：增值税1%')
                        d税率 = 0.01
                }
                // if (汇率) {
                //     d本币单价 = o.原币单价 * 汇率
                //     d本币含税单价 = o.原币单价 * 汇率 * (1 + d税率)
                //     d本币未税金额 = o.原币单价 * 汇率 * o.数量
                //     d本币含税金额 = o.原币单价 * 汇率 * (1 + d税率) * o.数量
                //     d合计金额 = d合计金额 + d本币含税金额
                // }
                d本币单价 = o.原币单价
                d本币含税单价 = o.原币单价 * (1 + d税率)
                d本币未税金额 = o.原币单价 * o.数量
                d本币含税金额 = o.原币单价 * (1 + d税率) * o.数量

                // 保留两位小数
                d本币未税金额 = (Math.round(d本币未税金额 * 100) / 100).toFixed(2);
                d本币含税金额 = (Math.round(d本币含税金额 * 100) / 100).toFixed(2);

                d合计金额 = d合计金额 + d本币含税金额
                changeListItem(this,
                    {
                        '本币单价': d本币单价,
                        '本币含税单价': d本币含税单价,
                        '本币未税金额': d本币未税金额,
                        '本币含税金额': d本币含税金额
                    },
                    {
                        '本币单价': 'string',
                        '本币含税单价': 'string',
                        '本币未税金额': 'string',
                        '本币含税金额': 'string'
                    },
                    '请购明细', '请购明细', o.id)
            })
            var newAllList = list.filter(o => o.id != id)
            newAllList.forEach(o => {
                d合计金额 = d合计金额 + o.本币含税金额
            })
            Tyan.utility.changeItemsValue(this, '基本信息', '合计金额', d合计金额)
        }
    }

    bChanged = () => {
        return hasChangedValues(this)
    }
    s
    canSave = () => {
        const { list } = getListItems(this, '请购明细', '请购明细')
        return getFormValue(this, '基本信息', '币别') && list.filter(o => !o.用途).length == 0
            && list.filter(o => o.数量 == 0).length == 0 && list.filter(o => o.本币单价 == 0).length == 0
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    fieldset基本信息 = () => {
        const 状态 = getFormValue(this, '基本信息', '状态')
        const { readOnly } = this.props
        const s = { margin: '5px 15px 5px 15px', minWidth: 150, flex: 1 }
        const { list } = getListItems(this, '请购明细', '请购明细')
        var _fieldset = [
            { _text: '请购单号', minWidth: '45%', disabled: true },
            { _date: '申请时间', minWidth: '45%', disabled: true },
            { _text: '申请人', minWidth: '45%', disabled: true },
            { _text: '申请部门', minWidth: '45%', disabled: true },
            { _radio: '请购类型', minWidth: '95%' },
            { _radio: '加急件', minWidth: '45%', },
            { _date: '预计需求日期', name: '要求送达日期', minWidth: '45%' },
            { _select: '币别', minWidth: '45%', onChange: (v) => this.handleCurrencyNameChange(v), required: true },
            { _float: '汇率', minWidth: '45%', disabled: true, textAlign: 'left', decimals: 4 },
            { _float: '合计金额', minWidth: '45%', disabled: true, decimals: 2 },
            { _text: '请购项目', minWidth: '90%', disabled: true, maxRows: 3 },
            { _files: '附件', minWidth: '90%', disabled: 状态 !== '请购议价' && 状态 !== '申请中' },
            { _text: '备注', minWidth: '90%', maxRows: 3 },
        ]
        var _items = []
        list.forEach((o, iNo) => {
            const _list = { listName: '请购明细', id: o.id }
            _fieldset.push({
                _border: `请购明细${iNo + 1}`, name: `请购明细[${o.id}]`, list: _list, margin: '15 0 5 0', minWidth: '90%', fieldset: '请购明细', items: [
                    // { _radio: '请购状态', itemMinWidth: 125, minWidth: '45%', disabled: readOnly || 状态 == '申请中' || 状态 == '已完成', cdt: () => 状态 != '申请中' },
                    // { _text: '不予采购人', minWidth: '45%', cdt: () => 状态 != '申请中' && o.请购状态 == '不予采购', },
                    { _text: '物料名称', disabled: true, minWidth: '45%' },
                    { _text: '制造商名称', name:'制造商名称', disabled: true, minWidth: '45%' },
                    { _text: '单位', disabled: true, minWidth: '45%' },
                    { _text: '规格型号', disabled: true, minWidth: '45%', },
                    { _float: '数量', onChange: () => this.AutoCalculation(o.id), minWidth: '45%', required: true },
                    { _float: '单价', name: '原币单价', decimals: 4, onChange: () => this.AutoCalculation(o.id), minWidth: '45%', required: true },
                    { _float: '金额', name: '本币含税金额', disabled: true, minWidth: '95%' },
                    { _text: '用途', minWidth: '95%', required: true },
                    { _select: '使用部门', minWidth: '45%' },
                    { _text: '物料代码', disabled: true, minWidth: '45%' },
                    { _text: '类别', minWidth: '45%', disabled: true, },
                    { _text: '资产大类', disabled: true, minWidth: '45%', },
                    //{ _date: '建议采购日期', minWidth: '45%', },
                    // { _date: '到货日期', minWidth: '45%', required: true },
                    { _select: '受益设备', editable: true, minWidth: '95%' },
                    // { _float: '原币单价', onChange: () => this.AutoCalculation(o.id), minWidth: '45%' },
                    // { _float: '本币单价', disabled: true, minWidth: '45%' },
                    // { _select: '税率', onChange: () => this.AutoCalculation(o.id), minWidth: '45%' },
                    // { _float: '本币含税单价', disabled: true, minWidth: '45%' },
                    // { _float: '本币未税金额', disabled: true, minWidth: '45%' },
                    // { _float: '本币含税金额', disabled: true, minWidth: '95%' },
                    {
                        _buttons: [
                            {
                                _button: '删除', icon: 'trash-o', ui: 'decline', margin: 0, hidden: readOnly || 状态 !== '申请中',
                                handler: () => Tyan.pubForm.showConfirm('确定要删除？', () => { this.handlerDeleteInfo(o.id) }),
                            },
                            // {
                            //     _button: '不予采购', icon: '', ui: 'decline', margin: 0, hidden: readOnly || 状态 == '申请中' || 状态 == '已完成' || o.请购状态 == '不予采购',
                            //     handler: () => Tyan.pubForm.showConfirm('确定不采购？', () => { this.handlerNoPurchase(o.id) }),
                            // }
                        ], margin: 0, layout: { type: 'hbox', pack: 'end', align: 'center' }
                    },
                ]
            })
        })
        return _fieldset
    }

    fieldset流转日志 = () => {
        return [
            { _html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'left' } }]
    }

    fieldset签核流程 = () => {
        return [
            { _html: '', name: '签核流程', minWidth: '95%', style: { textAlign: 'left' } }]
    }

    render() {
        const { showMessage: Message, showBody: Body, readOnly } = this.props
        const { initValues基本信息, id } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const { 状态, 提交时间 } = initValues基本信息
        return <Body data={this} maxWidth="100%"
            controls={
                readOnly ? [
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ] :
                    [
                        { _flow: 'RequisitionFlow', cdt: () => id > 0, disabled: this.bChanged() || !this.canSave() },
                        // { _button: '打印', icon: 'print', handler: this.handlerAdvanceExport, cdt: () => id > 0, },
                        { _button: '选择物料...', icon: 'plus', handler: () => this.handlerSave('选择物料'), cdt: () => 状态 == '申请中' },
                        { _button: '保存', icon: 'save', handler: () => this.handlerSave(''), disabled: !(this.canSave() && this.bChanged()), cdt: () => 状态 != '已完成' },
                        { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0 && 状态 == '申请中' && 提交时间 == nullDate, handler: this.handlerDelete, disabled: this.bChanged() },
                        { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                    ]}
            fieldsets={
                [
                    { title: '基本信息', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: readOnly || 状态 !== '申请中' },
                    {
                        _fieldsets: [
                            { title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), fullblock: true },
                            { title: '签核流程', name: '基本信息', _fieldset: this.fieldset签核流程(), fullblock: true },
                        ], docked: 'right', width: '40%',
                    }
                ]}
        />
    }
}

export default connect()(RequisitionDiv)